import { InfoButton } from '../../components/connectedForm/Button';
import BusinessRulesToggleMutation from '../../graphql/mutations/schedules/BusinessRulesToggleMutation.graphql';
import { getActionProps } from '../../utils/getActionProps';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import getClientMutationId from '../../utils/getClientMutationId';

export const workspace = [
  {
    component: InfoButton,
    description: 'Enable',
    call: props => toggleBusinessRule(props, true),
    mutation: BusinessRulesToggleMutation,
    mutationWrapper: {
      subjectSuccess: 'Business rules activated',
      messageSuccess: 'Business rules have been enabled.',
    },
  },
  {
    component: InfoButton,
    description: 'Disable',
    call: props => toggleBusinessRule(props, false),
    mutation: BusinessRulesToggleMutation,
    mutationWrapper: {
      subjectSuccess: 'Business rules deactivated',
      messageSuccess: 'Business rules have been disabled.',
    },
  },
];

function toggleBusinessRule(props, toggle) {
  let actionProps = normalizeVariables(getActionProps(props, 'businessRules', 'Company/BusinessRules/Workspace'));

  return {
    variables: {
      input: {
        clientMutationId: getClientMutationId(),
        ...actionProps,
        toggle: toggle,
      },
    },
  };
}
